import Link from 'next/link';
import { Fragment, useMemo } from 'react';

const DELIMITER = '/';

const CommonBreadcrumbs = props => {
  const { paths } = props;

  const links = useMemo(() => {
    return paths.map(({ text, path, current }, index) => {
      return (
        <Fragment key={text}>
          {index !== 0 ? <span className='mx-[20px]'>{DELIMITER}</span> : null}

          {current ? (
            <span className='font-sans leading-[1.4] text-title'>{text}</span>
          ) : (
            <Link
              className='font-sans leading-[1.4] text-[#666] hover_underline'
              href={path}
            >
              {text}
            </Link>
          )}
        </Fragment>
      );
    });
  }, [paths]);

  return <div className='hidden lg_block'>{links}</div>;
};

export default CommonBreadcrumbs;
